import { useOptionsStore } from "@/entities"
import { ChangeLangAndVoiceSettings } from "@/features"
import styles from "./styles.module.scss"

export const ChangeVoicePage = () => {
  const options = useOptionsStore(s => s.data)

  if (!options) return null

  return (
    <div className={styles.page}>
      <ChangeLangAndVoiceSettings
        voice={options.voice}
        voiceLang={options.voiceLang}
        voiceName={options.voiceName}
      />
    </div>
  )
}
